import { render, staticRenderFns } from "./SignUpStep.vue?vue&type=template&id=b08d92be&scoped=true&"
import script from "./SignUpStep.vue?vue&type=script&lang=js&"
export * from "./SignUpStep.vue?vue&type=script&lang=js&"
import style0 from "./SignUpStep.vue?vue&type=style&index=0&id=b08d92be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08d92be",
  null
  
)

export default component.exports